export type ErrorWithMessage = {
  message: string;
};

export const isObjectWithMessage = (error: any): error is ErrorWithMessage => 'message' in error;
